/* tslint:disable */
/* eslint-disable */
/**
 * The Thing API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    FolderSearchStatus,
    FolderSearchStatusFromJSON,
    FolderSearchStatusFromJSONTyped,
    FolderSearchStatusToJSON,
} from './';

/**
 * 
 * @export
 * @interface InterrogatoryQueryFolderInfo
 */
export interface InterrogatoryQueryFolderInfo {
    /**
     * 
     * @type {string}
     * @memberof InterrogatoryQueryFolderInfo
     */
    folderId?: string;
    /**
     * 
     * @type {string}
     * @memberof InterrogatoryQueryFolderInfo
     */
    parentFolderId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof InterrogatoryQueryFolderInfo
     */
    name?: string | null;
    /**
     * 
     * @type {FolderSearchStatus}
     * @memberof InterrogatoryQueryFolderInfo
     */
    folderSearchStatus?: FolderSearchStatus;
    /**
     * 
     * @type {number}
     * @memberof InterrogatoryQueryFolderInfo
     */
    totalFileCount?: number;
    /**
     * 
     * @type {number}
     * @memberof InterrogatoryQueryFolderInfo
     */
    relevantFileCount?: number;
}

export function InterrogatoryQueryFolderInfoFromJSON(json: any): InterrogatoryQueryFolderInfo {
    return InterrogatoryQueryFolderInfoFromJSONTyped(json, false);
}

export function InterrogatoryQueryFolderInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): InterrogatoryQueryFolderInfo {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'folderId': !exists(json, 'folderId') ? undefined : json['folderId'],
        'parentFolderId': !exists(json, 'parentFolderId') ? undefined : json['parentFolderId'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'folderSearchStatus': !exists(json, 'folderSearchStatus') ? undefined : FolderSearchStatusFromJSON(json['folderSearchStatus']),
        'totalFileCount': !exists(json, 'totalFileCount') ? undefined : json['totalFileCount'],
        'relevantFileCount': !exists(json, 'relevantFileCount') ? undefined : json['relevantFileCount'],
    };
}

export function InterrogatoryQueryFolderInfoToJSON(value?: InterrogatoryQueryFolderInfo | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'folderId': value.folderId,
        'parentFolderId': value.parentFolderId,
        'name': value.name,
        'folderSearchStatus': FolderSearchStatusToJSON(value.folderSearchStatus),
        'totalFileCount': value.totalFileCount,
        'relevantFileCount': value.relevantFileCount,
    };
}


